export function getStrategyTransitionAction(recommendations, strategyContext, activeStrategy = null) {
  if (recommendations?.strategy_transition?.type !== 'strategy_completed') return null;
  // This insight belongs to an older completed strategy. Once a different
  // successor is active, preserve the audit card but make its CTA reflect the
  // completed follow-through instead of inviting duplicate generation.
  const hasActiveSuccessor = Boolean(activeStrategy?._id && activeStrategy?.timeline?.isComplete === false);
  if (hasActiveSuccessor && (!strategyContext?.strategy_id
    || String(strategyContext.strategy_id) !== String(activeStrategy._id))) {
    return { label: 'Strategy & Plan completed', completed: true };
  }
  const canManage = strategyContext?.can_manage_strategy === true
    || (strategyContext?.is_dojo_strategy !== true && strategyContext?.can_manage_strategy !== false);
  return canManage
    ? { label: 'Build next Strategy & Plan', startNewOnOpen: true }
    : { label: 'Open Strategy & Plan', startNewOnOpen: false };
}

export function shouldAutoStartStrategyTransition({ requested, loading, authorityLoading, readOnly, started }) {
  return Boolean(requested && !loading && !authorityLoading && !readOnly && !started);
}

export function shouldOpenStrategyTransition({ startNewOnOpen, lastOpenedAt, now = Date.now() }) {
  return !startNewOnOpen || !lastOpenedAt || now - lastOpenedAt >= 1000;
}
